<i18n lang="yaml">
pt:
  title: 'Autenticação Multi-Fator'
  subtitle: 'Para finalizar seu login, acesse seu dispositivo conectado'
en:
  title: 'Multifactor Authentication'
  subtitle: 'To finish signing in, access your MFA device'
</i18n>
<template>
  <AuthLogin
    :layout-attrs="layoutAttrs"
    :modules="[
      'mfa'
    ]"
  />
</template>

<script lang="ts">
import AuthLogin from '~/components/auth/login/index.vue';

export default defineComponent({
  name: 'MFA',
  components: { AuthLogin },
  setup() {
    const { t } = useI18n();

    definePageMeta({
      middleware: ['auth-redirect'],
    });

    useAnalyticsPage('auth-tenant-mfa');

    return { t };
  },
  computed: {
    layoutAttrs() {
      return {
        title: this.t('title'),
        subtitle: this.t('subtitle'),
        hideSignUpDisclaimer: true,
      };
    },
  },
});
</script>
